var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.type)?_c('div',{staticClass:"preview-blank"},[_c('div',{staticClass:"blank-wrap",style:(_vm.blankStyle)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }